import styles from './line-ui.module.scss'

export const LineUI = () => <div className={styles.line}></div>